import React from "react"

import { changeLocale, useIntl } from "gatsby-plugin-intl"

import '../../styles/global.css'
import {StaticImage} from 'gatsby-plugin-image'


const languageName = {
  en: "English",
  hy: "հայերեն", 
  ru: "русский",
  fa: "فارسی",
  fr: "française"
}

const Language = () => {
  const intl = useIntl()
  let currentLocale = languageName[intl.locale];
  
  return (
          <div>
            <button className='language-button' onClick={()=> changeLocale('en') }>
              <StaticImage 
                  src='../../../static/img/flags/united-kingdom.png'
                  className='flags'
                  alt="A dinosaur"
                  style = {{
                    opacity: currentLocale === 'English' ? `1` : `0.5`,
                    outline: currentLocale === 'English' ? '2px solid #f5f5f5' : ''
                  }}
              />
            </button>
            <button className='language-button' onClick={()=> changeLocale('hy') }>
              <StaticImage 
                  src='../../../static/img/flags/armenia.png'
                  className='flags'
                  style = {{
                    opacity: currentLocale === 'հայերեն' ? `1` : `0.5`,
                    outline: currentLocale === 'հայերեն' ? '2px solid #f5f5f5' : ''
                  }}
              />
            </button>
            <button className='language-button' onClick={()=>changeLocale('ru') }>
              <StaticImage 
                  src='../../../static/img/flags/russia.png'
                  className='flags'
                  style = {{
                    opacity: currentLocale === 'русский' ? `1` : `0.5`,
                    outline: currentLocale === 'русский' ? '2px solid #f5f5f5' : ''
                  }}
              />
            </button>
            <button className='language-button' onClick={()=>changeLocale('fa') }>
              <StaticImage 
                  src='../../../static/img/flags/iran.png'
                  className='flags'
                  style = {{
                    opacity: currentLocale === 'فارسی' ? `1` : `0.5`,
                    outline: currentLocale === 'فارسی' ? '2px solid #f5f5f5' : ''
                  }}
              />
            </button>
            <button className='language-button' onClick={()=>changeLocale('fr') }>
              <StaticImage 
                  src='../../../static/img/flags/france.png'
                  className='flags'
                  style = {{
                    opacity: currentLocale === 'française' ? `1` : `0.5`,
                    outline: currentLocale === 'française' ? '2px solid #f5f5f5' : ''
                  }}
              />
            </button>
          </div>
  )
}

export default Language
